import { render, staticRenderFns } from "./_ArchiveButton.vue?vue&type=template&id=10e12701"
import script from "./_ArchiveButton.vue?vue&type=script&lang=js"
export * from "./_ArchiveButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports